// API for testing or Development

const browserDomain = window.location.origin;

let API_Root;

if (browserDomain.includes("localhost")){
    API_Root = "http://127.0.0.1:8000/";
    // API_Root = "https://api-woyera.com/";
    // USE THIS FOR LOCAL DEV
    //  API_Root = "https://6gi3x2gv8k.execute-api.us-east-1.amazonaws.com/"
}
else{
    API_Root = "https://api-woyera.com/";
}


export default API_Root